import AbstractFilterDefinition from './AbstractFilterDefinition.js'

export default class CheckboxFilterDefinition extends AbstractFilterDefinition
{
    constructor(name, label, options, isIntegerValues = false) {
        super(name, label);
        this.options = options;
        this.isIntegerValues = isIntegerValues;
        this.arrayKeys = [];
    }

    get component() {
        return 'checkbox-filter';
    }

    dataAdapter(data) {
        let choices = [];

        if (this.arrayKeys.length > 0) {
            data.choices.forEach((id) => {
                if (this.arrayKeys.indexOf(id) != -1) {
                    //Array
                    id = id.split(',');
                    choices = choices.concat(id);
                } else {
                    choices.push(id);
                }
            });
        } else {
            choices = data.choices;
        }

        choices = this.isIntegerValues ? choices.map((value) => parseInt(value)) : choices;
        return choices.length > 0 ? choices : null;
    }

    get configuration() {
        let options = typeof this.options == 'function' ? this.options() : this.options;

        let formatterOptions = {};
        for (let key in options) {
            let id = options[key].id;
            if (Array.isArray(id)) {
                id = id.join(',');
                this.arrayKeys.push(id);
            }
            formatterOptions[id] = {
                value: id,
                label: options[key].label,
                rank: 0,
            };
        }

        let configuration =  {
            "choices": {
                "name": "choices",
                "type": "checkbox",
                "options": formatterOptions
            },
            "mode": {
                "type": "radio",
                "name": "mode",
                "options": {
                    "is": {
                        "default": true,
                        "value": "is",
                        "label": i18n.__("Est égal à")
                    },
                }
            }
        };
        return configuration;
    }
}